import React from 'react';
import { Box } from '../box';
import { Typography } from '../typography';

export interface IAreaRightSideBoxDetailProps {
  children?: React.ReactNode;
  label?: React.ReactNode;
}

export class AreaRightSideBoxDetailColumns {
  public static label = 'label';
  public static value = 'value';
}

export function AreaRightSideBoxDetail(props: IAreaRightSideBoxDetailProps) {
  const { label = '', children } = props;
  return (
    <Box display="flex" justifyContent="space-between" px={2} py={1}>
      <Typography variant="body2" data-testid={AreaRightSideBoxDetailColumns.label}>
        {label}
      </Typography>
      <Box data-testid={AreaRightSideBoxDetailColumns.value} ml={1}>
        {children}
      </Box>
    </Box>
  );
}
